<template>
  <div class="main-wrapper">
    <div class="has_consuls">
      <p>
        <span
          :class="
            accountForOther[0] || accountForOther[1]
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Счет открывается обособленному подразделению юридического лица (филиалу,
        представительству)
      </p>
      <label>
        <input
          type="checkbox"
          v-model="accountForOther[0]"
          @click="accountForOther = [accountForOther[0], false]"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('IS_ACCOUNT_FOR_BRANCH') != -1
          "
        />ДА
      </label>
      <label>
        <input
          type="checkbox"
          v-model="accountForOther[1]"
          @click="
            accountForOther = [false, accountForOther[1]];
            files[0].FILE = null;
            files[1].FILE = null;
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('IS_ACCOUNT_FOR_BRANCH') != -1
          "
        />НЕТ
      </label>
      <div v-if="accountForOther[0]">
        <p
          class="necessary-table-not"
          v-if="!(files[1].FILE != null && files[0].FILE != null)"
        >
          Приложите ВСЕ документы.
        </p>
        <p class="min-one-file">
          Вы можете приложить только один файл или архив. Если необходимо
          приложить несколько документов, добавьте документы в архив и
          прикрепите архив.
        </p>
        <table>
          <tr>
            <td>Тип</td>
            <td>Файл</td>
          </tr>
          <tr>
            <td>Положение об обособленном подразделении</td>
            <td width="250px">
              <input
                v-show="files[0].FILE == null"
                type="file"
                id="file"
                ref="file_one"
                accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
                v-on:change="checkFileFillOne()"
                @click="
                  files[0].FILE = null;
                  validation();
                "
              />
              <div
                class="file-name-icon"
                v-if="files[0].FILE != null"
                @click="onClickBan('file_one')"
              >
                <div class="icons">
                  <i class="fa fa-trash"></i>
                </div>
                <p class="file-name">{{ files[0].FILE.name }}</p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              Документы, подтверждающие полномочия руководителя обособленного
              подразделения юридического лица
            </td>
            <td width="250px">
              <input
                v-show="files[1].FILE == null"
                type="file"
                id="file"
                ref="file_two"
                accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
                v-on:change="checkFileFillTwo()"
                @click="
                  files[1].FILE = null;
                  validation();
                "
              />
              <div
                class="file-name-icon"
                v-if="files[1].FILE != null"
                @click="onClickBan('file_two')"
              >
                <div class="icons">
                  <i class="fa fa-trash"></i>
                </div>
                <p class="file-name">{{ files[1].FILE.name }}</p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="main-has-sovet">
      <p>
        <span
          :class="hasSovet[0] || hasSovet[1] ? 'valid-field' : 'unvalid-field'"
          >➤</span
        >
        Наличие Совета директоров/Наблюдательного совета/иных органов управления
        согласно Уставу
      </p>
      <label>
        <input
          type="checkbox"
          v-model="hasSovet[0]"
          @click="hasSovet = [hasSovet[0], false]"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('HAS_CONRTOL_BOARD') != -1
          "
        />ДА
      </label>
      <label>
        <input
          type="checkbox"
          v-model="hasSovet[1]"
          @click="
            hasSovet = [false, hasSovet[1]];
            file_sovet.FILE = null;
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('HAS_CONRTOL_BOARD') != -1
          "
        />НЕТ
      </label>
      <div v-if="hasSovet[0]">
        <p class="necessary-table-not" v-if="!(file_sovet.FILE != null)">
          Приложите документ.
        </p>
        <p class="min-one-file">
          Вы можете приложить только один файл или архив. Если необходимо
          приложить несколько документов, добавьте документы в архив и
          прикрепите архив.
        </p>
        <table>
          <tr>
            <td>Тип</td>
            <td>Файл</td>
          </tr>
          <tr>
            <td>
              Протокол/Решение общего собрания участников/акционеров об избрании
              членов Совета директоров/Наблюдательного совета/иных органов
            </td>
            <td width="250px">
              <input
                v-show="file_sovet.FILE == null"
                type="file"
                id="file"
                ref="file_sovet"
                accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
                v-on:change="checkFileSovet"
                @click="
                  file_sovet.FILE = null;
                  validation();
                "
              />
              <div
                class="file-name-icon"
                v-if="file_sovet.FILE != null"
                @click="onClickBan('file_sovet')"
              >
                <div class="icons">
                  <i class="fa fa-trash"></i>
                </div>
                <p class="file-name">{{ file_sovet.FILE.name }}</p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="main-has-other-faces">
      <p>
        <span
          :class="
            hasOtherFaces[0] || hasOtherFaces[1]
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Наличие лиц (кроме единоличного исполнительного органа), уполномоченных
        распоряжаться денежными средствами, находящимися на счете
      </p>
      <label>
        <input
          type="checkbox"
          v-model="hasOtherFaces[0]"
          @click="hasOtherFaces = [hasOtherFaces[0], false]"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('HAS_ANOTHER_ACCRULERS') != -1
          "
        />ДА
      </label>
      <label>
        <input
          type="checkbox"
          v-model="hasOtherFaces[1]"
          @click="
            hasOtherFaces = [false, hasOtherFaces[1]];
            files_faces[0].FILE = null;
            files_faces[1].FILE = null;
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('HAS_ANOTHER_ACCRULERS') != -1
          "
        />НЕТ
      </label>
      <div v-if="hasOtherFaces[0]">
        <p
          class="necessary-table-not"
          v-if="!(files_faces[1].FILE != null && files_faces[0].FILE != null)"
        >
          Приложите ВСЕ документы.
        </p>
        <p class="min-one-file">
          Вы можете приложить только один файл или архив. Если необходимо
          приложить несколько документов, добавьте документы в архив и
          прикрепите архив.
        </p>
        <table>
          <tr>
            <td>Тип</td>
            <td>Файл</td>
          </tr>
          <tr>
            <td>
              Приказ и/или доверенность на распоряжение денежными средствами,
              находящимися на счете
            </td>
            <td width="250px">
              <input
                v-show="files_faces[0].FILE == null"
                type="file"
                id="file"
                ref="files_faces_one"
                accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
                v-on:change="checkFileFaces(0)"
                @click="
                  files_faces[0].FILE = null;
                  validation();
                "
              />
              <div
                class="file-name-icon"
                v-if="files_faces[0].FILE != null"
                @click="onClickBan('files_faces_one')"
              >
                <div class="icons">
                  <i class="fa fa-trash"></i>
                </div>
                <p class="file-name">{{ files_faces[0].FILE.name }}</p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              Документ, удостоверяющий личность (для иностранных граждан или лиц
              без гражданства миграционная карта и документ подтверждающий
              пребывание на территории РФ)
            </td>
            <td width="250px">
              <input
                v-show="files_faces[1].FILE == null"
                type="file"
                id="file"
                ref="files_faces_two"
                accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
                v-on:change="checkFileFaces(1)"
                @click="
                  files_faces[1].FILE = null;
                  validation();
                "
              />
              <div
                class="file-name-icon"
                v-if="files_faces[1].FILE != null"
                @click="onClickBan('files_faces_two')"
              >
                <div class="icons">
                  <i class="fa fa-trash"></i>
                </div>
                <p class="file-name">{{ files_faces[1].FILE.name }}</p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyHasSovet",
  props: {
    pageInfo: {},
    pageName: String,
  },
  data: () => ({
    hasSovet: [false, false],
    hasOtherFaces: [false, false],
    file_sovet: {
      FILE: null,
      CAPTION:
        "Протокол/Решение общего собрания участников/акционеров об избрании членов Совета директоров/Наблюдательного совета/иных органов",
    },
    files_faces: [
      {
        FILE: null,
        CAPTION:
          "Приказ и/или доверенность на распоряжение денежными средствами, находящимися на счете",
      },
      {
        FILE: null,
        CAPTION:
          "Документ, удостоверяющий личность (для иностранных граждан или лиц без гражданства миграционная карта и документ подтверждающий пребывание на территории РФ)",
      },
    ],
    accountForOther: [false, false],
    files: [
      { FILE: null, CAPTION: "Положение об обособленном подразделении" },
      {
        FILE: null,
        CAPTION:
          "Документы, подтверждающие полномочия руководителя обособленного подразделения юридического лица",
      },
    ],
    sendData: {},
  }),
  methods: {
    onClickBan(name) {
      switch (name) {
        case "files_faces_two": {
          if (
            this.files_faces[1].DISABLED == null ||
            !this.files_faces[1].DISABLED
          ) {
            this.files_faces[1].FILE = null;
            let input = this.$refs.files_faces_two;
            input.type = "text";
            input.type = "file";
          }
          break;
        }
        case "files_faces_one": {
          if (
            this.files_faces[0].DISABLED == null ||
            !this.files_faces[0].DISABLED
          ) {
            this.files_faces[0].FILE = null;
            let input = this.$refs.files_faces_one;
            input.type = "text";
            input.type = "file";
          }
          break;
        }
        case "file_sovet": {
          if (this.file_sovet.DISABLED == null || !this.file_sovet.DISABLED) {
            this.file_sovet.FILE = null;
            let input = this.$refs.file_sovet;
            input.type = "text";
            input.type = "file";
          }
          break;
        }
        case "file_two": {
          if (this.files[1].DISABLED == null || !this.files[1].DISABLED) {
            this.files[1].FILE = null;
            let input = this.$refs.file_two;
            input.type = "text";
            input.type = "file";
          }
          break;
        }
        case "file_one": {
          if (this.files[0].DISABLED == null || !this.files[0].DISABLED) {
            this.files[0].FILE = null;
            let input = this.$refs.file_one;
            input.type = "text";
            input.type = "file";
          }
          break;
        }
      }
    },
    validation() {
      let sovetIsOk =
        this.hasSovet[1] || (this.hasSovet[0] && this.file_sovet.FILE != null);
      let facesIsOk =
        this.hasOtherFaces[1] ||
        (this.hasOtherFaces[0] &&
          this.files_faces[0].FILE != null &&
          this.files_faces[1].FILE != null);
      let filialOk =
        this.accountForOther[1] ||
        (this.accountForOther[0] &&
          this.files[0].FILE != null &&
          this.files[1].FILE != null);
      var msg = "";
      if (!(this.accountForOther[0] || this.accountForOther[1]))
        msg +=
          "Нобходимо заполнить поля:<br>• Счет открывается обособленному подразделению;<br>";
      if (!(this.hasSovet[0] || this.hasSovet[1]))
        msg +=
          msg.length == 0
            ? "Нобходимо заполнить поля:<br>• Наличие Совета директоров/Наблюдательного совета/иных органов управления согласно Уставу;<br>"
            : "• Наличие Совета директоров/Наблюдательного совета/иных органов управления согласно Уставу;<br>";
      if (!(this.hasOtherFaces[0] || this.hasOtherFaces[1]))
        msg +=
          msg.length == 0
            ? "Нобходимо заполнить поля:<br>• Наличие лиц, уполномоченных распоряжаться денежными средствами, находящимися на счете;<br>"
            : "• Наличие лиц, уполномоченных распоряжаться денежными средствами, находящимися на счете;<br>";
      if (
        (this.accountForOther[0] &&
          !(this.files[0].FILE != null && this.files[1].FILE != null)) ||
        (this.hasOtherFaces[0] &&
          !(
            this.files_faces[0].FILE != null && this.files_faces[1].FILE != null
          )) ||
        (this.hasSovet[0] && this.file_sovet.FILE == null)
      )
        msg += "Приложите ВСЕ документы";
      this.$emit("enableButtons", true, msg);
      if (sovetIsOk && facesIsOk && filialOk) {
        this.createSendData();
        this.$emit(
          "changePageSendData",
          this.sendData,
          this.sendData.FILES != null && this.sendData.FILES.length > 0
        );
      }
    },
    checkFileFillOne() {
      if (
        (this.files[1].FILE != null &&
          this.files[1].FILE.name == this.$refs.file_one.files[0].name) ||
        (this.files_faces[0].FILE != null &&
          this.files_faces[0].FILE.name == this.$refs.file_one.files[0].name) ||
        (this.files_faces[1].FILE != null &&
          this.files_faces[1].FILE.name == this.$refs.file_one.files[0].name) ||
        (this.file_sovet.FILE != null &&
          this.file_sovet.FILE.name == this.$refs.file_one.files[0].name)
      ) {
        this.$alert(
          "Файл " + this.$refs.file_one.files[0].name + " уже загружен"
        );
        let input = this.$refs.file_one;
        input.type = "text";
        input.type = "file";
      } else if (this.$refs.file_one.files[0].size > 31457280) {
        this.$alert(
          "Размер файла " +
            this.$refs.file_one.files[0].name +
            " превышает допустимый размер (30 МБ)"
        );
        let input = this.$refs.file_one;
        input.type = "text";
        input.type = "file";
      } else this.files[0].FILE = this.$refs.file_one.files[0];
      this.validation();
      this.$emit("updated");
    },
    checkFileFillTwo() {
      if (
        (this.files[0].FILE != null &&
          this.files[0].FILE.name == this.$refs.file_two.files[0].name) ||
        (this.files_faces[0].FILE != null &&
          this.files_faces[0].FILE.name == this.$refs.file_two.files[0].name) ||
        (this.files_faces[1].FILE != null &&
          this.files_faces[1].FILE.name == this.$refs.file_two.files[0].name) ||
        (this.file_sovet.FILE != null &&
          this.file_sovet.FILE.name == this.$refs.file_two.files[0].name)
      ) {
        this.$alert(
          "Файл " + this.$refs.file_two.files[0].name + " уже загружен"
        );
        let input = this.$refs.file_two;
        input.type = "text";
        input.type = "file";
      } else if (this.$refs.file_two.files[0].size > 31457280) {
        this.$alert(
          "Размер файла " +
            this.$refs.file_two.files[0].name +
            " превышает допустимый размер (30 МБ)"
        );
        let input = this.$refs.file_two;
        input.type = "text";
        input.type = "file";
      } else this.files[1].FILE = this.$refs.file_two.files[0];
      this.validation();
      this.$emit("updated");
    },
    checkFileSovet() {
      if (
        (this.files_faces[0].FILE != null &&
          this.files_faces[0].FILE.name ==
            this.$refs.file_sovet.files[0].name) ||
        (this.files_faces[1].FILE != null &&
          this.files_faces[1].FILE.name ==
            this.$refs.file_sovet.files[0].name) ||
        (this.files[0].FILE != null &&
          this.files[0].FILE.name == this.$refs.file_sovet.files[0].name) ||
        (this.files[1].FILE != null &&
          this.files[1].FILE.name == this.$refs.file_sovet.files[0].name)
      ) {
        this.$alert(
          "Файл " + this.$refs.file_sovet.files[0].name + " уже загружен"
        );
        let input = this.$refs.file_sovet;
        input.type = "text";
        input.type = "file";
      } else if (this.$refs.file_sovet.files[0].size > 31457280) {
        this.$alert(
          "Размер файла " +
            this.$refs.file_sovet.files[0].name +
            " превышает допустимый размер (30 МБ)"
        );
        let input = this.$refs.file_sovet;
        input.type = "text";
        input.type = "file";
      } else this.file_sovet.FILE = this.$refs.file_sovet.files[0];
      this.validation();
      this.$emit("updated");
    },
    createSendData() {
      this.sendData.HAS_CONRTOL_BOARD = this.hasSovet[0];
      this.sendData.HAS_ANOTHER_ACCRULERS = this.hasOtherFaces[0];
      this.sendData.IS_ACCOUNT_FOR_BRANCH = this.accountForOther[0];
      this.sendData.FILES = [];
      if (this.checkUploadFiles(this.file_sovet))
        this.sendData.FILES.push(this.file_sovet);
      this.files.forEach((item) => {
        if (this.checkUploadFiles(item)) this.sendData.FILES.push(item);
      });
      this.files_faces.forEach((item) => {
        if (this.checkUploadFiles(item)) this.sendData.FILES.push(item);
      });
    },
    checkFileFaces(index) {
      if (index == 0) {
        if (
          (this.file_sovet.FILE != null &&
            this.file_sovet.FILE.name ==
              this.$refs.files_faces_one.files[0].name) ||
          (this.files_faces[1].FILE != null &&
            this.files_faces[1].FILE.name ==
              this.$refs.files_faces_one.files[0].name) ||
          (this.files[0].FILE != null &&
            this.files[0].FILE.name ==
              this.$refs.files_faces_one.files[0].name) ||
          (this.files[1].FILE != null &&
            this.files[1].FILE.name == this.$refs.files_faces_one.files[0].name)
        ) {
          this.$alert(
            "Файл " + this.$refs.files_faces_one.files[0].name + " уже загружен"
          );
          let input = this.$refs.files_faces_one;
          input.type = "text";
          input.type = "file";
        } else if (this.$refs.files_faces_one.files[0].size > 31457280) {
          this.$alert(
            "Размер файла " +
              this.$refs.files_faces_one.files[0].name +
              " превышает допустимый размер (30 МБ)"
          );
          let input = this.$refs.files_faces_one;
          input.type = "text";
          input.type = "file";
        } else this.files_faces[0].FILE = this.$refs.files_faces_one.files[0];
      } else if (index == 1) {
        if (
          (this.file_sovet.FILE != null &&
            this.file_sovet.FILE.name ==
              this.$refs.files_faces_two.files[0].name) ||
          (this.files_faces[0].FILE != null &&
            this.files_faces[0].FILE.name ==
              this.$refs.files_faces_two.files[0].name) ||
          (this.files[0].FILE != null &&
            this.files[0].FILE.name ==
              this.$refs.files_faces_two.files[0].name) ||
          (this.files[1].FILE != null &&
            this.files[1].FILE.name == this.$refs.files_faces_two.files[0].name)
        ) {
          this.$alert(
            "Файл " + this.$refs.files_faces_two.files[0].name + " уже загружен"
          );
          let input = this.$refs.files_faces_two;
          input.type = "text";
          input.type = "file";
        } else if (this.$refs.files_faces_two.files[0].size > 31457280) {
          this.$alert(
            "Размер файла " +
              this.$refs.files_faces_two.files[0].name +
              " превышает допустимый размер (30 МБ)"
          );
          let input = this.$refs.files_faces_two;
          input.type = "text";
          input.type = "file";
        } else this.files_faces[1].FILE = this.$refs.files_faces_two.files[0];
      }
      this.validation();
      this.$emit("updated");
    },
    checkUploadFiles(item) {
      let needToSend = false;
      let isExist = false;
      if (this.pageInfo.FILES != null) {
        this.pageInfo.FILES.forEach((file) => {
          if (file.DESCRIPTION == item.CAPTION) {
            if (item.FILE != null) {
              needToSend = item.FILE.name != file.DS_FILE_NAME;
            } else {
              needToSend = file.DS_FILE_NAME != null;
            }
            isExist = true;
          }
        });
        if (!isExist) needToSend = item.FILE != null;
      } else {
        needToSend = item.FILE != null;
      }
      return needToSend;
    },
  },
  async created() {
    this.sendData.INN = this.pageInfo.INN;

    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    if (this.pageInfo.HAS_CONRTOL_BOARD != null)
      this.pageInfo.HAS_CONRTOL_BOARD
        ? (this.hasSovet = [true, false])
        : (this.hasSovet = [false, true]);
    if (this.pageInfo.HAS_ANOTHER_ACCRULERS != null)
      this.pageInfo.HAS_ANOTHER_ACCRULERS
        ? (this.hasOtherFaces = [true, false])
        : (this.hasOtherFaces = [false, true]);
    if (this.pageInfo.IS_ACCOUNT_FOR_BRANCH != null)
      this.pageInfo.IS_ACCOUNT_FOR_BRANCH
        ? (this.accountForOther = [true, false])
        : (this.accountForOther = [false, true]);
    if (this.pageInfo.FILES != null) {
      let files = this.pageInfo.FILES;
      files.forEach((item) => {
        this.files_faces.forEach((a) => {
          if (a.CAPTION == item.DESCRIPTION) {
            if (item.DS_FILE_NAME != null) {
              a.FILE = { name: item.DS_FILE_NAME };
            }
            a.DISABLED = item.DISABLED != null && item.DISABLED;
          }
        });
        this.files.forEach((a) => {
          if (a.CAPTION == item.DESCRIPTION) {
            if (item.DS_FILE_NAME != null) {
              a.FILE = { name: item.DS_FILE_NAME };
            }
            a.DISABLED = item.DISABLED != null && item.DISABLED;
          }
        });
        if (this.file_sovet.CAPTION == item.DESCRIPTION) {
          if (item.DS_FILE_NAME != null) {
            this.file_sovet.FILE = { name: item.DS_FILE_NAME };
          }
          this.file_sovet.DISABLED = item.DISABLED != null && item.DISABLED;
        }
      });
    }
    this.validation();
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
table {
  border-collapse: collapse;
  margin-top: 10px;
  width: 100%;
}
td {
  border: 1px solid black;
  padding: 5px 10px;
}
.necessary {
  color: red;
}
.min-one-file {
  text-align: center;
  font-size: 12px;
}
.icons {
  position: absolute;
  padding-left: 255px;
  padding-top: 5px;
  background-color: white;
  border: none;
  color: red;
  font-size: 17px;
}
</style>
